import { off, onValue, ref } from 'firebase/database';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { convertHelpers } from 'global/common/convert';
import { useContext, useEffect, useState } from 'react';
import { useRtdbListener } from './useRtdbListener';

export function useMatchDayResults() {

  const parentContext = useContext(ParentContext);

  const { states } = parentContext ?? {};
  const { app_state, paps_state } = states ?? {};

  const { pathViews } = paps_state ?? {};
  const { app_ts } = app_state ?? {};

  const [matchDayResults, setMatchDayResults] = useState({});

  const path_sport = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${pathViews.sports}`;

  // const { data, loading } = useRtdbListener(
  //   app_ts?.realtime,
  //   app_ts?.app,
  //   path_sport,
  //   {
  //     initialValue: {},
  //     transform: (v) => v || {},
  //   }
  // );

  // useEffect(() => {

  //   if (!app_ts?.realtime || !pathViews?.sports) return;

  //   // const path_sport = `clients/${pathViews.clients}/events/${pathViews.events}/matchDayResults/${pathViews.sports}`;

  //   console.log('path_sport', path_sport)
  //   console.log('DB APP:', app_ts?.realtime);

  //   const _ref = ref(app_ts.realtime, path_sport);

  //   const handleValue = (snapshot) => {
  //     const value = snapshot.val() || {};
  //     console.log('⚡⚡', value)
  //     setMatchDayResults(value);
  //   };

  //   onValue(_ref, (snapshot) => {
  //     const r = convertHelpers.createKeyedObject(snapshot.val())
  //     console.log('r', r)
  //     setMatchDayResults(r);
  //   });

  //   // LIVE listener
  //   // onValue(_ref, handleValue);

  //   // cleanup
  //   // return () => {
  //   //   off(_ref, 'value', handleValue);
  //   // };

  // }, [
  //   app_ts?.realtime,
  //   pathViews?.clients,
  //   pathViews?.events,
  //   pathViews?.sports,
  // ]);

  return matchDayResults;
}